module.exports = __webpack_public_path__ + "img/AFRICA_LOW_GLYCEMIC.52ab0743.png";